import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class SlackOAuthAppId extends PrimitiveValueObject<string> {
  static create(value: string): SlackOAuthAppId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new SlackOAuthAppId(value);
  }
}
